import React, { useState, useEffect } from 'react';
import api from './api'; 

const GalaxyPriceManager = () => {
    // Data States
    const [workers, setWorkers] = useState([]); // Changed from parties to workers
    const [prices, setPrices] = useState([]);
    
    // Selection States
    const [selectedWorker, setSelectedWorker] = useState("");
    
    // Form States
    const [serviceName, setServiceName] = useState("");
    const [rate, setRate] = useState("");

    // Load Workers on mount
    useEffect(() => {
        loadWorkers();
    }, []);

    // Load Prices when Worker changes
    useEffect(() => {
        if (selectedWorker) {
            loadPrices(selectedWorker);
        } else {
            setPrices([]);
        }
    }, [selectedWorker]);

    const loadWorkers = async () => {
        try {
            // Fetch only 'Galaxy' department workers
            const res = await api.get('/job-workers?dept=Galaxy'); 
            setWorkers(res.data);
        } catch (err) { console.error("Error loading workers", err); }
    };

    const loadPrices = async (workerId) => {
        try {
            const res = await api.get(`/galaxy-prices/list/${workerId}`);
            setPrices(res.data);
        } catch (err) { console.error("Error loading prices", err); }
    };

    const handleAddRate = async (e) => {
        e.preventDefault();
        if (!selectedWorker) return alert("Please select a Worker first.");
        if (!serviceName || !rate) return alert("Please fill all fields.");

        try {
            await api.post('/galaxy-prices/add', {
                jobWorker: selectedWorker, // Sending correct ID
                serviceName,
                ratePerPiece: parseFloat(rate)
            });
            
            setServiceName("");
            setRate("");
            loadPrices(selectedWorker);
        } catch (err) {
            alert("Error: " + (err.response?.data?.message || err.message));
        }
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Delete this rate?")) return;
        try {
            await api.delete(`/galaxy-prices/${id}`);
            loadPrices(selectedWorker);
        } catch (err) { console.error(err); }
    };

    return (
        <div className="container mt-4">
            <h3 className="mb-4 fw-bold text-primary">💰 Galaxy Rate Master</h3>

            <div className="row">
                {/* --- LEFT: ADD NEW RATE --- */}
                <div className="col-md-4">
                    <div className="card shadow-sm">
                        <div className="card-header bg-dark text-white">Add New Rate</div>
                        <div className="card-body">
                            <form onSubmit={handleAddRate}>
                                <div className="mb-3">
                                    <label className="form-label">Select Galaxy Worker</label>
                                    <select 
                                        className="form-select" 
                                        value={selectedWorker}
                                        onChange={(e) => setSelectedWorker(e.target.value)}
                                    >
                                        <option value="">-- Select Worker --</option>
                                        {workers.map(w => (
                                            <option key={w._id} value={w._id}>{w.name}</option>
                                        ))}
                                    </select>
                                    <div className="form-text">List shows only 'Galaxy' Dept workers.</div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Service / Size Name</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="e.g. 0-10 cents (Small)"
                                        value={serviceName}
                                        onChange={(e) => setServiceName(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Rate (Per Piece)</label>
                                    <div className="input-group">
                                        <span className="input-group-text">₹</span>
                                        <input 
                                            type="number" 
                                            className="form-control" 
                                            placeholder="0.00"
                                            value={rate}
                                            onChange={(e) => setRate(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-primary w-100" disabled={!selectedWorker}>
                                    ➕ Save Rate
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* --- RIGHT: RATE LIST --- */}
                <div className="col-md-8">
                    <div className="card shadow-sm">
                        <div className="card-header bg-light d-flex justify-content-between">
                            <strong>Current Rate Card</strong>
                            {selectedWorker && <span className="badge bg-info text-dark">Worker ID: {selectedWorker}</span>}
                        </div>
                        <div className="card-body p-0">
                            {!selectedWorker ? (
                                <div className="p-5 text-center text-muted">
                                    Select a Worker from the left to view their rates.
                                </div>
                            ) : prices.length === 0 ? (
                                <div className="p-5 text-center text-muted">
                                    No rates found. Add one!
                                </div>
                            ) : (
                                <table className="table table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Service Name</th>
                                            <th>Rate / Piece</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {prices.map((p) => (
                                            <tr key={p._id}>
                                                <td className="fw-bold">{p.serviceName}</td>
                                                <td className="text-success fw-bold">₹{p.ratePerPiece}</td>
                                                <td>
                                                    <button 
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => handleDelete(p._id)}
                                                    >
                                                        🗑️
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GalaxyPriceManager;